import { HIDE_BOOKING_SUCCESS } from "./types";

const hideBookingSuccess = () => ({
  type: HIDE_BOOKING_SUCCESS,
});

export default hideBookingSuccess;
